import { BookOpen, Globe, Search } from "lucide-react";
import DocsSection from "./sections/docs-section";
import DocsFeaturesDetail from "./sections/docs-features-detail";
import DocsContentFlow from "./sections/docs-content-flow";
import CTASection from "../../components/cta-section";
import { useTranslation } from "../../i18n";

export default function NewDocsRoute() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-500 opacity-90" />

      {/* Diagonal White Section */}
      <div className="absolute top-0 left-0 right-0 h-[670px] -z-5">
        <div className="absolute top-0 left-0 right-0 h-full bg-white transform -skew-y-6 origin-top-left translate-y-[30%]" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 px-4 md:px-8 pt-16 pb-24">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-6xl font-bold text-navy-900 leading-tight">
              {t("routes.docs.heroTitle")}
              <br />
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-violet-600 via-purple-600 to-orange-500">
                {t("routes.docs.heroHighlight")}
              </span>
            </h1>
            <p className="mt-6 text-gray-700 text-lg">
              {t("routes.docs.heroDescription")}
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-blue-100 flex items-center justify-center">
                  <BookOpen className="h-5 w-5 text-blue-600" />
                </div>
                <span className="text-sm font-medium">
                  {t("routes.docs.unlimitedArticles")}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-purple-100 flex items-center justify-center">
                  <Globe className="h-5 w-5 text-purple-600" />
                </div>
                <span className="text-sm font-medium">
                  {t("routes.docs.languages")}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-indigo-100 flex items-center justify-center">
                  <Search className="h-5 w-5 text-indigo-600" />
                </div>
                <span className="text-sm font-medium">
                  {t("routes.docs.aiSearch")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* JUHUU Docs Main Section */}
      <DocsSection />

      {/* Detailed Features */}
      <DocsFeaturesDetail />

      {/* Content Flow Visualization */}
      <DocsContentFlow />
      <div id="contact">
        <CTASection />
      </div>
    </div>
  );
}
